import React, { useState } from "react";
import { useImportProjectMutation } from "../../store/slices/settingsSlice";
import MyModal from "../../Common/MyModal";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import WhiteButton from "../../Common/WhiteButton";
import ContactsIcon from "../../../assets/icons/contact_edit.svg2";
import JsonCollapse from "./JsonCollapse";
import FullScreenLoadingIndicator from "../../Common/FullScreenLoadingIndicator";
import SolutionImportCheckFields from "../../Solutions/SolutionImportCheckFields";
import HelpButton from "../../HelpContent/HelpButton";

export default function ProjectImportModal() {
  const [importedJSON, setImportedJSON] = useState<any>();
  const [manualFields, setManualFields] = useState<string[]>([]);
  const [importProject] = useImportProjectMutation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  return (
    <MyModal
      label={
        <WhiteButton
          as="span"
          icon={ContactsIcon}
          heading="Import"
          subheading="Solution"
          target={undefined}
          disabled={false}
        />
      }
      heading={
        <span>
          Import Solution <HelpButton helpKey="import-solution" />
        </span>
      }
      onShow={() => setImportedJSON(undefined)}
      size="xxl"
    >
      <FullScreenLoadingIndicator loading={loading} />
      <Form.Control
        className="mb-3"
        type="file"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const file = e.target.files?.[0];
          if (!file) return;
          setLoading(true);
          const reader = new FileReader();
          reader.readAsText(file, "UTF-8");
          reader.onload = function ({ target }) {
            setImportedJSON(JSON.parse(target?.result as string));
            setLoading(false);
          };
          reader.onerror = function () {
            setImportedJSON(undefined);
            setLoading(false);
          };
        }}
      />
      {!!importedJSON && (
        <div
          className="bg-white p-2 rounded-2"
          style={{ maxHeight: "700px", overflowY: "auto" }}
        >
          <SolutionImportCheckFields
            importedJSON={importedJSON}
            setImportedJSON={setImportedJSON}
            manualFields={manualFields}
            setManualFields={setManualFields}
          />
        </div>
      )}
      <button
        className="btn btn-colored"
        onClick={async () => {
          if (!importedJSON) return;

          const result: any = await importProject(importedJSON);

          if (result?.data) {
            toast.success("Project imported successfully");
            navigate(`/library/logic/builder/${result.data.project.ID}`);
          }
        }}
      >
        Import Solution
      </button>
    </MyModal>
  );
}
